// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PublicHolidayListPagingResultModel from '../../model/public-holiday-list-paging-result-model';
import PublicHolidayListPagingResultDTO from '../dto/public-holiday-list-paging-result-dto';
import dtoSchema from '../schemas/public-holiday-list-paging-result-schema';
import PublicHolidayListModel from '../../model/public-holiday-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class PublicHolidayListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PublicHolidayListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => PublicHolidayListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: PublicHolidayListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<PublicHolidayListPagingResultDTO>): PublicHolidayListPagingResultModel;
  static toModel(dto: DeepPartial<PublicHolidayListPagingResultDTO> | undefined | null): PublicHolidayListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<PublicHolidayListPagingResultDTO> | undefined | null): PublicHolidayListPagingResultModel | undefined {
    return dto ? new PublicHolidayListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PublicHolidayListPagingResultModel> | PublicHolidayListPagingResultModel): PublicHolidayListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as PublicHolidayListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PublicHolidayListPagingResultModel, can not map to PublicHolidayListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
